module.exports = __webpack_public_path__ + "static/media/my-mortgage.2c4a1ca2.svg";